module.exports = __webpack_public_path__ + "static/media/impasta_noodle.172abf55.gif";